<app-sidebar [hidden]="true"></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
	<p style="color: white"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="sidenav">
	<div class="login-main-text">
		<div class="col-md-12 text-center ">
			<img src="assets/images/bsflogo.png" alt="BRD Logo" class="brand-image img-circle elevation-3"
				style="opacity: .8; background-color: white; width: 150px; height: 150px; text-align: center;">
			<br><br>
			<h2>ระบบไร่ออนไลน์<br> หน้าเข้าสู่ระบบ</h2>
		</div>

		<!--<div class="col-md-6 text-center" *ngFor="let item of alldata">
			<p style="color: white;">ชื่อนักส่งเสริม {{ item.supname }}</p>
			<img id="profileimg" src="{{item.suppic_url}}" alt="supportterbrd" width="150px" height="150px">
		</div>-->

	</div>

</div>
<div class="main">
	<div class="col-md-6 col-sm-12">
		<div class="login-form">
			<mat-form-field class="example-form-field" appearance="outline">
				<mat-label>ชื่อผู้ใช้งาน</mat-label>
				<input matInput type="text" [(ngModel)]="user_log.username" required>
			</mat-form-field>

			<mat-form-field class="example-form-field" appearance="outline">
				<mat-label>รหัสผ่าน</mat-label>
				<input matInput [type]="hide ? 'password' : 'text'" [(ngModel)]="user_log.password" required>
				<button matSuffix mat-icon-button (click)="hide = !hide" [attr.aria-label]="'Hide password'"
					[attr.aria-pressed]="hide">
					<mat-icon style="color: red;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
				</button>
			</mat-form-field>
			<section>
				<div class="example-button-row">
					<button mat-raised-button color="primary" (click)="OnLogin()"
						[disabled]="(user_log.username.length!<2&&user_log.password.length!<2)">Login</button>
				</div>
			</section>
		</div>
		<mat-progress-bar *ngIf="isload" mode="indeterminate"></mat-progress-bar>
	</div>

	<div class="snowflakes" aria-hidden="true">
		<div class="snowflake"> ❅ </div>
		<div class="snowflake"> ❄ </div>
		<div class="snowflake"> ❅ </div>
		<div class="snowflake"> ❆ </div>
		<div class="snowflake"> ❅ </div>
		<div class="snowflake"> ❄ </div>
		<div class="snowflake"> ❅ </div>
		<div class="snowflake"> ❄ </div>
	</div>
</div>